import React, { createRef, useState, useEffect, useContext } from "react";

import {
  getDAMSSearchResults,
  postListofImages2Veeva,
  getImageLists,
} from "../../services/apis";
import "./DAMSSearchModal.scss";
import { getBrandAndMarketCamp } from "../../utils/editorUtils/commonFunctions";
import CircularProgressBar from "../../utils/CircularProgressBar";
import NotFoundImage from "../../images/NotFoundImage.svg";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "../../images/Close-Small.svg";
import SuccessIcon from "../../images/Success-Icon.svg";
import ErrorIcon from "../../images/Error-Icon.svg";
import LibrarySearchIcon from "../../images/library-searchIcon.svg";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

const DAMSSearchModal = ({
  setShowDAMSModel,
  deckData,
  brands,
  market,
  campaign,
  setLoadedImages,
  loadedImages,
}) => {
  const [searchText, setSearchText] = useState("");
  const [damsSearchResults, setDamsSearchResults] = useState([]);
  const [selectedDAMS, setSelectedDAMS] = useState([]);
  const [damsLoading, setDamsLoading] = useState(false);
  const [notFoundMess, setNotFoundMess] = useState(false);

  const handleChangeSearchText = (e) => {
    const searchedValue = e.target.value;
    setSearchText(searchedValue);
  };

  const getSearchData = () => {
    if (searchText === "") {
      return;
    }
    setDamsLoading(true);
    getDAMSSearchResults(
      deckData._id,
      searchText,
      (response, err, errorCode) => {
        if (err) {
          setDamsLoading(false);
        } else {
          setDamsLoading(false);
          const damsResults = response?.data?.response;
          setDamsSearchResults(damsResults);
          setSelectedDAMS([]);
          setNotFoundMess(true);
        }
      }
    );
  };

  const validateForm = () => {
    if (searchText) {
      return false;
    }
    return true;
  };

  const validateImport = () => {
    if (selectedDAMS && selectedDAMS?.length > 0) {
      return false;
    }
    return true;
  };

  const checkboxhandler = (e, selectedList) => {
    if (e.target.checked) {
      var index = loadedImages.damsList?.findIndex(
        (list) => list.imageName == selectedList.imageName
      );
      if (index !== -1) {
        showErrorToast('Selected Image is already imported');
      } else {
        setSelectedDAMS((result) => [...result, selectedList]);
      }
    } else {
      const copySelectedDAMS = selectedDAMS.slice();
      const filtered = selectedDAMS.findIndex(
        (list) => list.imageid == selectedList.imageid
      );
      copySelectedDAMS.splice(filtered, 1);
      setSelectedDAMS(copySelectedDAMS);
    }
  };

  const resetSearchResult = () => {
    setSearchText("");
    setDamsSearchResults([]);
    setSelectedDAMS([]);
    setNotFoundMess(false);
  };

  const PostImagestoVeeva = () => {
    setDamsLoading(true);
    postListofImages2Veeva(
      { images: selectedDAMS },
      deckData.brand,
      (response, err, errorCode) => {
        if (err) {
          setDamsLoading(false);
          // const errCoponent = ErrComponentToRender(errorCode);
        } else {
          setDamsLoading(false);
          // console.log("response", response);
          getImageLists((response, err, errorCode) => {
            if (err) {
              // const errCoponent = ErrComponentToRender(errorCode);
            } else {
              setLoadedImages(response.data);
            }
          });
          showSuccessToast('Image import successful');
        }
        setShowDAMSModel(false);
      }
    );
  };

  var isChecked = (item) => (selectedDAMS.includes(item) ? true : false);

  return (
    <>
      <div className="searchModal d_selectModal DAMSModal">
        <div className="model-inside-body">
          <div
            className="row"
            style={{ paddingLeft: "10px", paddingRight: "0px" }}
          >
            <div className="col-md-4 searchTitle pt-2">
              Import Image from DAMS
            </div>
            <div className="col-md-8">
              <div className="d-flex justify-content-end DAMSModalBrandDetails">
                <div>
                  <span>Product/Brand</span>{" "}
                  {getBrandAndMarketCamp("brand", brands, deckData, market)}
                </div>
                <div>
                  <span>Campaign</span>
                  {getBrandAndMarketCamp("campaign", brands, deckData, market)}
                </div>
                <div>
                  <span>Market </span>
                  {getBrandAndMarketCamp("market", brands, deckData, market)}
                </div>
              </div>
            </div>
          </div>
          <div
            className="row mt-4"
            style={{ paddingLeft: "10px", paddingRight: "0px" }}
          >
            <div className="col-md-10 Dams-search-col">
              {/* <TextField
                id="outlined-basic"
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
                label="Document Name / ID"
                variant="outlined"
                size="small"
                value={searchText}
                className="Dams-searchField"
                style={{
                  fontSize: "12px",
                }}
                onChange={handleChangeSearchText}
                //onKeyUp={handleEnterKeypress}
              /> */}
              <div className="d-flex template-searchRow DAMS-Search">
                <img
                  alt="search"
                  src={LibrarySearchIcon}
                  className={"searchManagerIcon"}
                ></img>
                <input
                  value={searchText}
                  className="Dams-searchField"
                  style={{
                    fontSize: "12px",
                  }}
                  type="text"
                  name="searchInput"
                  placeholder="Document Name / ID"
                  onChange={handleChangeSearchText}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="col-md-2 import-btn-reset">
              <button
                className="btn searchPirmaryBtn"
                type="button"
                onClick={(e) => getSearchData(e)}
                disabled={searchText === ""}
              >
                SEARCH
              </button>
              <button
                className="btn btn-link searchLinkBtn"
                type="button"
                disabled={validateForm()}
                onClick={() => resetSearchResult()}
              >
                Reset
              </button>
            </div>
          </div>
          <div
            className="row mt-4"
            style={{ paddingLeft: "10px", paddingRight: "0px" }}
          >
            <div className="col-md-12">
              <div className="DAMSModulesResults">
                Search Results (
                {damsSearchResults?.length > 0 ? damsSearchResults?.length : 0})
              </div>
            </div>
          </div>

          <div className="searchResultsContainer customScrollBar">
            <div className="row DAMS-search-result">
              {damsLoading && (
                <CircularProgressBar
                  isloading={damsLoading}
                  setIsloading={setDamsLoading}
                />
              )}
              {damsSearchResults && damsSearchResults.length < 1 ? (
                <div className="no-result d-flex justify-content-center align-items-center">
                  <img src={NotFoundImage} />
                  {notFoundMess && (
                    <p>
                      <span className="no-result-found">No Result Found,</span>{" "}
                      <span className="try-again">Please try Again</span>
                    </p>
                  )}
                </div>
              ) : (
                damsSearchResults &&
                damsSearchResults.map((result, index) => (
                  <div key={index} className="col-md-3 mb-4 d-flex d_content">
                    <div className="d-flex align-items-center justify-content-center">
                      <label>
                        <input
                          type="checkbox"
                          value={result.imageid}
                          name={result.imageid}
                          className="de-checkbox"
                          onChange={(e) => checkboxhandler(e, result)}
                          checked={isChecked(result)}
                        />
                      </label>
                      <img
                        className="img-fluid"
                        src={result?.imageProductionLink}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="row searhModalFooterRow  dams-footer align-items-center">
          <div className="col-md-6">
            <span className="searchModuleSelectedCount">
              {/* {userSelctedModuleList && userSelctedModuleList?.length > 0 ? (
                <> {userSelctedModuleList?.length} Module Selected</>
              ) : (
                <p className="tip">
                  Tip: To select a module, click on the module cards
                </p>
              )} */}
            </span>
          </div>
          <div className="col-md-6 text-end model-bottom-btn">
            <button
              className="btn btn-link searchLinkBtn mr-2"
              onClick={() => {
                setShowDAMSModel(false);
              }}
            >
              CANCEL
            </button>
            <button
              className={`
                btn searchProceedBtn text-uppercase`}
              onClick={() => {
                PostImagestoVeeva();
              }}
              disabled={validateImport()}
            >
              IMPORT
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DAMSSearchModal;
